// extracted by mini-css-extract-plugin
module.exports = {"ArticleByline":"ArticleByline__2S5BO","ArticleByline_name":"ArticleByline_name__2S5BO","ArticleByline_title":"ArticleByline_title__2S5BO"};